// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__5DEcG","clinicsSelect":"TableHeading_clinicsSelect__2_x20"};